import React from 'react'

const CartPage = () => {
  return ( 
    <div>
      This is your cart page
    </div>
  )
}

export default CartPage